import React, { useEffect } from 'react';
import { Form } from '@ant-design/compatible';
import BrandDetailProductRegisterTradingCondition from '../BrandDetailProductRegisterTradingCondition';
import BrandDetailProductRegisterAddDeliveryCharge from '../BrandDetailProductRegisterAddDeliveryCharge';
import BrandDetailProductRegisterDelivery from '../BrandDetailProductRegisterDelivery';
import BrandDetailProductRegisterAfterService from '../BrandDetailProductRegisterAfterService';
import BrandDetailProductRegisterHeader from '../BrandDetailProductRegisterHeader';
import { useBrandDetailProductRegister } from '../../../../../hooks/brand/detail/useBrandDetailProductRegister';
import { useEdit } from '../../../../../hooks/common/useEdit';
import { useQuery } from '../../../../../hooks/common/useQuery';

const BrandDetailProductRegisterSection = ({ form, storeId }) => {
  const query = useQuery();
  const tab = query.get('tabKey');
  const { onSubmitEditProductRegisterInfo, brandDetailProductRegisterInfo } = useBrandDetailProductRegister(
    storeId,
    form,
  );
  const { isEditable, edit, cancelEdit } = useEdit(form);

  useEffect(() => {
    return () => {
      if (tab === '5') {
        cancelEdit();
      }
    };
  }, [tab]);

  const { tradingConditionsInfo, addDeliveryChargeInfo, deliveryInfo, afterServiceInfo } =
    brandDetailProductRegisterInfo;

  return (
    <div className="brand-detail-product-register-section">
      <Form onSubmit={onSubmitEditProductRegisterInfo}>
        <BrandDetailProductRegisterHeader isEditable={isEditable} edit={edit} cancelEdit={cancelEdit} />
        {/*거래조건에 관한 정보*/}
        <BrandDetailProductRegisterTradingCondition data={tradingConditionsInfo} isEditable={isEditable} form={form} />

        {/*추가 배송비*/}
        <BrandDetailProductRegisterAddDeliveryCharge data={addDeliveryChargeInfo} isEditable={isEditable} form={form} />

        {/*배송 정보*/}
        <BrandDetailProductRegisterDelivery
          data={deliveryInfo}
          isEditable={isEditable}
          form={form}
          key={`${tab}-${isEditable ? 'edit' : 'view'}`}
        />

        {/*A/S*/}
        <BrandDetailProductRegisterAfterService data={afterServiceInfo} isEditable={isEditable} form={form} />
      </Form>
    </div>
  );
};

export default Form.create()(BrandDetailProductRegisterSection);
